function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "interview",
  transform: "translate(0.000000, -2.000000)",
  fill: "#3B3A42"
}, React.createElement("path", {
  d: "M22,2 C25.313,2 28,4.73495652 28,8.10852174 L28,14.2170435 C28,17.5895652 25.313,20.7826087 22,20.7826087 L11,20.7826087 C10.004,23.333913 8.053,24.9575652 4.162,24.9575652 C4.109,24.9575652 4.056,24.9575652 4.002,24.9565217 C3.208,24.9471304 2.565,24.3721739 2.896,23.6354783 C3.388,22.5377391 3.911,21.1217391 3.971,19.9593043 C1.657,19.1109565 0,16.8643478 0,14.2170435 L0,8.10852174 C0,4.73495652 2.687,2 6,2 L22,2 Z M22,4.08695652 L6,4.08695652 C3.794,4.08695652 2,5.89113043 2,8.10852174 L2,14.2170435 C2,15.896 3.059,17.4132174 4.634,17.9902609 C5.472,18.2970435 6.016,19.1453913 5.968,20.0709565 C5.927,20.8702609 5.732,21.7843478 5.388,22.8017391 C7.817,22.5022609 8.642,21.2907826 9.147,19.9958261 C9.454,19.2090435 10.187,18.6956522 11,18.6956522 L22,18.6956522 C24.093,18.6956522 26,16.5606957 26,14.2170435 L26,8.10852174 C26,5.89113043 24.206,4.08695652 22,4.08695652 Z",
  id: "Combined-Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "23px",
    viewBox: "0 0 28 23",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/interview.94f7a087.svg";
export { SvgComponent as ReactComponent };